(function ($, Drupal) {
  function mobileFooterMenu() {
    $(".menu--footer > ul > li > span")
      .attr("tabindex", "0")
      .on("click keydown", function (e) {
        if (e.type === "click" || e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          $(this).parent().toggleClass("active");
        }
      });
  }

  function desktopFooterMenu() {
    $(".menu--footer > ul > li > span")
      .removeAttr("tabindex")
      .off("click keydown");
  }

  // shorthand for document ready
  $(function () {
    let siteFooterLogo = $(".site-footer__top-left"),
      siteBottomRight = $(".site-footer__bottom-right"),
      siteFooterTop = $(".site-footer__top");

    const footerLogoInit = () => {
      siteFooterTop.prepend(siteFooterLogo);
    };

    const footerLogoTablet = () => {
      siteBottomRight.prepend(siteFooterLogo);
    };

    enquire.register("screen and (max-width: 767px)", {
      match: function () {
        mobileFooterMenu();
      },
    });

    enquire.register("screen and (min-width: 768px)", {
      match: function () {
        desktopFooterMenu();
      },
    });

    enquire.register("screen and (min-width: 768px) and (max-width: 1199px)", {
      match: function () {
        // do stuff
        footerLogoTablet();
      },
      unmatch: function () {
        // do stuff
        footerLogoInit();
      },
    });
  });
})(jQuery, Drupal);
